export default "__VITE_ASSET__CFSGK1u8__"